import type { CartItem, CartTotals } from '../model/types'
import { FREE_SHIPPING_THRESHOLD, DEFAULT_SHIPPING_FEE } from '../config/cart.config'

export function computeTotals(items: CartItem[]): CartTotals {
  const subtotal = items.reduce((s, it) => s + it.oldPrice * it.qty, 0)
  const discounted = items.reduce((s, it) => s + it.price * it.qty, 0)
  const discount = subtotal - discounted
  const itemCount = items.reduce((s, it) => s + it.qty, 0)
  const shippingFee = discounted === 0 || discounted >= FREE_SHIPPING_THRESHOLD ? 0 : DEFAULT_SHIPPING_FEE
  const grandTotal = discounted + shippingFee
  return { subtotal, discount, shippingFee, grandTotal, itemCount }
}

export function amountToFreeShipping(currentSubtotal: number): number {
  return Math.max(0, FREE_SHIPPING_THRESHOLD - currentSubtotal)
}
